import { Flex } from 'styled-system/jsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import FileTypeLabel from '@/common/components/fileTypeLabel/FileTypeLabel.tsx';
import { FileListDefaultHeaderType } from '@/common/components/DetailCard/headers/fileHeader/FileListDefaultHeader.type.ts';
import FileDetailModal from '@/modules/FileList/components/modals/fileDetailModals/FileDetailModal.tsx';

export default ({ index, fileType, fileDetail }: FileListDefaultHeaderType) => (
  <Flex
    borderBottom="2px dashed {colors.gray-2}"
    justifyContent="space-between"
    py="10px"
    w="90%"
    mx="auto"
  >
    <Flex alignItems="center">
      {index ? (
        <Typography
          textStyle="b4"
          color="black-4"
          pl="15px"
          pr="5px"
          borderLeft="1px solid {colors.gray-2}"
          ml="15px"
        >
          {index}
        </Typography>
      ) : null}

      <FileTypeLabel fileType={fileType} />
    </Flex>
    {fileDetail ? <FileDetailModal id={fileDetail.id} /> : null}
  </Flex>
);
